'use client';

import { ArticlePromoBlock } from '@components/v3/organisms/article-promo-block';
import { Locale } from '@core/constants/locales.constants';
import { ArticlePromo } from '@graphql/__generated__/graphql';
import { Translations } from '@lib/dictionary-keys/__generated__';
import { UseClient } from '@stadionhq-v3/base-ui';
import { CleanContentful } from '@stadionhq-v3/clean-contentful';
import { articlePromoTransform } from '@utils/transforms/components';

export type RenderArticlePromoBlockProps = {
  locale: Locale;
  dictionary: {
    readNewsArticle: Translations['news']['label']['readNewsArticle'];
    viewGalleryArticle: Translations['news']['label']['viewGalleryArticle'];
    watchVideoArticle: Translations['news']['label']['watchVideoArticle'];
  };
  props: CleanContentful<ArticlePromo>;
};

const RenderArticlePromoBlock = ({
  props,
  locale,
  dictionary,
}: RenderArticlePromoBlockProps) => (
  <UseClient>
    <ArticlePromoBlock
      {...articlePromoTransform(props, { locale, dictionary })}
    />
  </UseClient>
);

export default RenderArticlePromoBlock;
